import { useState } from "react";
import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useChat } from "@/contexts/ChatContext";

const SUGGESTED_PROMPTS = [
  "Compare CRMs for a solo agent",
  "Help me build a 90-day lead plan",
  "What tools should I cut to save money?",
];

export function AskCircleQuickCard() {
  const [query, setQuery] = useState("");
  const { openChatWithQuery } = useChat();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) {
      openChatWithQuery(query);
      setQuery("");
    }
  };

  const handleSuggestedPrompt = (prompt: string) => {
    openChatWithQuery(prompt);
  };

  return (
    <div className="w-full lg:max-w-md border rounded-lg p-6 shadow-sm bg-card">
      <div className="flex items-center gap-2 mb-3">
        <MessageCircle className="h-5 w-5 text-emerald-600" />
        <h2 className="text-lg font-semibold">
          <span>Ask</span>
          <span className="font-handelson font-extralight text-2xl ml-0.5">Circle</span>
        </h2>
      </div>
      
      <p className="text-sm text-muted-foreground mb-4">
        Ask anything about leads, tools, or your next 90 days. I'll use your shortlist and tech stack to answer.
      </p>
      
      <form onSubmit={handleSubmit} className="space-y-3">
        <Input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="I want 2 more closings a month. Where should I start?"
          className="w-full"
        />
        <Button type="submit" className="w-full" disabled={!query.trim()}>
          Ask Circle
        </Button>
      </form>

      <div className="mt-4 space-y-2">
        <p className="text-xs text-muted-foreground mb-2">Or try:</p>
        <div className="flex flex-wrap gap-2">
          {SUGGESTED_PROMPTS.map((prompt) => (
            <button
              key={prompt}
              onClick={() => handleSuggestedPrompt(prompt)}
              className="text-xs px-3 py-1.5 rounded-full border border-border hover:bg-accent transition-colors text-left"
            >
              {prompt}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
